import { financialPlanningPages } from "@app/const/route.const";
import { AddClientPage } from "./addClient/AddClientPage";
import { ClientListPage } from "./clientList/ClientListPage";
import { ClientSummaryPage } from "./clientSummary/ClientSummaryPage";
import { PlanInputPage } from "./planInput/PlanInputPage";
import { WorkbenchPage } from "./workbench/WorkbenchPage";
import { ProgressMonitoringPage } from "./progressMonitoring/ProgressMonitoringPage";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { FinancialPlanningReport } from "@app/features/financialPlanningReport/FinancialPlanningReport";
import { ActionReport } from "@app/features/actionReport/ActionReport";
import { TranslucenceChatPage } from "@app/pages/translucenceChat/TranslucenceChatPage";
import { XAIChatPage } from "@app/pages/xaiChat/XAIChatPage";
import { PolarisChatPage } from "@app/pages/xaiChat/PolarisChatPage";
import { PlanGuidePage } from "@app/pages/planGuide/PlanGuidePage";
import { MeetingGuidancePage } from "@app/pages/meetingGuidance/MeetingGuidancePage";
import { ThesysDemoPage } from "@app/pages/thesysDemo";
import { PromptResearchPage } from "@app/pages/promptResearch";

export const FinancialPlanningPage = () => {
  return (
    <AccessRouteControl
      items={[
        {
          path: financialPlanningPages.clientListPath,
          element: <ClientListPage />,
          moduleSection: CarModuleSectionCode.PLANNING_CLIENT_LIST,
        },
        {
          path: financialPlanningPages.addClientPath,
          element: <AddClientPage />,
          moduleSection: CarModuleSectionCode.PLANNING_ADD_CLIENT,
        },
        {
          path: financialPlanningPages.clientSummaryPath,
          element: <ClientSummaryPage />,
          moduleSection: CarModuleSectionCode.PLANNING_CLIENT_SUMMARY,
        },
        {
          path: financialPlanningPages.planInputPath,
          element: <PlanInputPage />,
          moduleSection: CarModuleSectionCode.PLANNING_PLAN_INPUT,
        },
        {
          path: financialPlanningPages.workbenchPath,
          element: <WorkbenchPage />,
          moduleSection: CarModuleSectionCode.PLANNING_WORKBENCH,
        },
        {
          path: financialPlanningPages.progressMonitoringPath,
          element: <ProgressMonitoringPage />,
          moduleSection: CarModuleSectionCode.PLANNING_PROGRESS_MONITORING,
        },
        {
          path: financialPlanningPages.pdfPlanningReportPath,
          element: <FinancialPlanningReport />,
          moduleSection: CarModuleSectionCode.PDF_PLANNING_REPORT,
        },
        {
          path: financialPlanningPages.pdfActionReportPath,
          element: <ActionReport />,
          moduleSection: CarModuleSectionCode.PDF_ACTION_REPORT,
        },
        {
          path: financialPlanningPages.translucenceChatPath,
          element: <TranslucenceChatPage />,
        },
        {
          path: financialPlanningPages.xaiChatPath,
          element: <XAIChatPage />,
        },
        {
          path: financialPlanningPages.polarisChatPath,
          element: <PolarisChatPage />,
        },
        {
          path: financialPlanningPages.planGuidePath,
          element: <PlanGuidePage />,
        },
        {
          path: financialPlanningPages.meetingGuidancePath,
          element: <MeetingGuidancePage />,
        },
        {
          path: financialPlanningPages.thesysDemoPath,
          element: <ThesysDemoPage />,
        },
        {
          path: financialPlanningPages.promptResearchPath,
          element: <PromptResearchPage />,
        },
      ]}
      defaultPath={financialPlanningPages.clientListPath}
    />
  );
};
